import { render, staticRenderFns } from "./DetailsPanel.vue?vue&type=template&id=83ee16ec"
import script from "./DetailsPanel.vue?vue&type=script&lang=ts"
export * from "./DetailsPanel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports